module.exports = __webpack_public_path__ + "static/media/affordability-tool-intro-page-checkmark.8de1a2bc.svg";